/**
 * theme-utils.ts
 * 
 * Central location for theme-related constants and utilities
 * to avoid duplication across the codebase.
 */

// Define the theme colors
export const themeColors = {
  // Light mode colors
  dusty: "#96858F",
  lavendar: "#6D7993",
  overcast: "#9099A2",
  paper: "#D5D5D5",
  textPrimary: "#1F2937", 
  textSecondary: "#4B5563",
  
  // Dark mode colors
  darkPaper: "#2D3748", 
  darkTextPrimary: "#E2E8F0",
  darkTextSecondary: "#A0AEC0",
  
  // Interactive elements
  buttonHoverBg: {
    light: 'rgba(0, 0, 0, 0.05)',
    dark: 'rgba(255, 255, 255, 0.1)'
  }
};

// Get theme-specific values based on dark mode state
export const getThemeValues = (isDarkMode: boolean) => ({
  paper: isDarkMode ? themeColors.darkPaper : themeColors.paper,
  border: isDarkMode ? themeColors.textSecondary : themeColors.overcast,
  textPrimary: isDarkMode ? themeColors.darkTextPrimary : themeColors.textPrimary,
  textSecondary: isDarkMode ? themeColors.darkTextSecondary : themeColors.textSecondary,
  buttonHoverBg: isDarkMode ? themeColors.buttonHoverBg.dark : themeColors.buttonHoverBg.light,
}); 